import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagAgentePercepcionFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagAgentePercepcion'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagAgentePercepcion'
          label='Es agente de percepción'
        />
      )}
    </Field>
  )
}

export default FlagAgentePercepcionFormGroup
